import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Box,
  // Grid,
  Link,
  Radio,
  Rating,
  Popover,
  Divider,
  TextField,
  RadioGroup,
  Typography,
  FormControl,
  Autocomplete,
  FormControlLabel,
  CircularProgress,
  IconButton
} from '@mui/material';
import _, { lowerCase } from 'lodash';
import axios from 'axios';
import moment from 'moment';
import {
  lockIcon,
  topicArray,
  bioFormatter,
  industryArray
  // GroupBasedRoleFormatter
} from '../../components/common';
import { API } from '../../../../api';
import { attributeKeys, events, eventTracking } from '../../../../utils/amplitude';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { Error } from '@mui/icons-material';
// import MyMentorCard from './MyMentorCard';
import { useAuth0 } from '@auth0/auth0-react';
import MenteeTaskPopup from './MenteeTaskPopup';
import CallBookingModal from '../CallBookingModal';
import GradeIcon from '@mui/icons-material/Grade';
// import { navigateToChat } from '../NavigateToChat';
import MCQQuestion from '../../components/MCQQuestion';
import '../../../../assets/style/sass/menteeTask.scss';
import { useQueryClient } from '@tanstack/react-query';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import { useModule } from '../../../../utils/useModule';
import UserinfoCard from '../../components/UserinfoCard';
import { levelTypes } from '../../../../utils/constants';
import MySkeleton from '../../../../components/Skeleton';
import { queryKeys } from '../../../../queries/queryKeys';
import { getUserDetails } from '../../../../utils/orgName';
import RenderHTML from '../../../../components/RenderHTML';
import {
  taskActions
  // fetchAllTasks
} from '../../../../redux/slices/goals-tasks/getTasksSlice';
import { useUserRole } from '../../../../utils/useUserRole';
import { mcqList } from '../../../../utils/dummyLoadingData';
import useRecMentors from '../../../../queries/useRecMentors';
import MentorViewBadge from '../../components/MentorViewBadge';
import useReCArticles from '../../../../queries/useRecArticles';
import DescriptionModal from '../../components/DescriptionModal';
import PreviewContent from '../Program/components/PreviewContent';
// import ChatWithMeDialog from '../../tabs/chat/ChatWithMeDialog';
import useAllGroupTasks from '../../../../queries/useAllGroupTasks';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getOrfiumLevelName } from '../../../../utils/orfiumFunctions';
import useUserDetailsById from '../../../../queries/useUserDetailsById';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { DeleteIcon, EditIcon, NotesIcon } from '../../../../utils/Icons';
import RecommendedArticle from '../Library/components/RecommendedArticle';
import { userIdUpdate } from '../../../../redux/slices/userId/userIdSlice';
import { Article } from '../Program/components/program tabs/ContentSettings';
import { saveAnswerActions } from '../../../../redux/slices/saveAnswersSlice';
import { MentorLoader, TasksLoader, TasksQuesLoader } from './TasksPageLoader';
import useResponsiveScreenSwitch from '../../../../utils/useResponsiveScreenSwitch';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import CheckIcon from '@mui/icons-material/Check';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { menteeTaskSlicAction } from '../../../../redux/slices/user-task/userMenteeTask';
import { getDecryptAns } from '../../../../utils/decryptAns';
import Confetti from 'react-confetti';
let source = axios.CancelToken.source();

interface TaskData {
  data: any;
}

interface MenteeTaskProps {
  selectedMenteeData?: {
    levelId: string;
    taskId: string;
    menteeDetails?: any;
  } | null;
  place?: string;
  onTaskSelect?: (levelId: string, taskId: string) => void;
}

const navigateTaskQuestionsToTop = (side: 'left' | 'right') => {
  if (side === 'left') {
    const [leftContainer] = window.document.getElementsByClassName('containerBoxLeft');
    if (leftContainer) {
      leftContainer.scrollTo(0, 0);
    }
  } else {
    const [rightContainer] = window.document.getElementsByClassName('containerBoxRight');
    if (rightContainer) {
      rightContainer.scrollTo(0, 0);
    }
  }
};
const topics = topicArray();
const industries = industryArray();

const MenteeTask = ({ selectedMenteeData, place = 'TaskPage', onTaskSelect }: MenteeTaskProps) => {
  // const groupAllGroupTasksDetails = useAllGroupTasks();
  const goalTasks = useAppSelector((state) => state.goalTasks);
  const location = useLocation();
  const { isMentor, isMentee } = useUserRole();
  const queryParams = new URLSearchParams(location.search);
  const userNameFromParams = decodeURIComponent(queryParams.get('userName') || '');
  const displayNameFromMentee = selectedMenteeData?.menteeDetails?.displayName
    ? decodeURIComponent(selectedMenteeData.menteeDetails.displayName)
    : '';

  const userName = userNameFromParams || displayNameFromMentee;
  const queryClient = useQueryClient();
  const { user } = useAuth0();
  const taskUserId = useAppSelector((state) => state.goalTasks.userId);

  const selectedGroupId = useAppSelector((state) => state.selectedGroup.data);
  // const allTaskData = useAppSelector((state) => state.goalTasks.data?.data[0]?.levels);
  const { refetch, isLoading, isFetching, data: userTaskData } = useAllGroupTasks(selectedGroupId.id, taskUserId);
  const allTaskData = userTaskData?.data.data[0]?.levels;
  const [selectedDropdownValues, setSelectedDropdownValues] = useState({ quesId: '', values: [] });
  const menteeTask = useAppSelector((state) => state?.goalTasks);
  const communityMembers = useAppSelector((state) => state.acsCommunityUsers.data);
  // const communityMembers = useAppSelector((state) => state.getCommunityMembers.data);
  const commList = useAppSelector((state) => state.getCommunityMembers.data);
  const { taskId: urlTaskId, levelId: urlLevelId } = useParams() || {};
  const modalTaskId = selectedMenteeData?.taskId;
  const modalLevelId = selectedMenteeData?.levelId;
  const taskId = place === 'Popup' ? modalTaskId : urlTaskId;
  const levelId = place === 'Popup' ? modalLevelId : urlLevelId;
  const userDetails = getUserDetails();
  const { coId, location: userLoc, orgId } = userDetails;

  const amplitudeBaseProps = useMemo(
    () => ({
      [attributeKeys.programName]: selectedGroupId?.name || '',
      [attributeKeys.userRole]: selectedGroupId?.role || '',
      [attributeKeys.userName]: userName || userDetails.name || '',
      [attributeKeys.organizationName]: userDetails.orgName || ''
    }),
    [selectedGroupId?.name, selectedGroupId?.role, userName, userDetails.name, userDetails.orgName]
  );

  const {
    data: recArticles,
    refetch: fetchRecArticles,
    isLoading: articlesLoading,
    isFetching: articlesFetching
  } = useReCArticles({
    grpId: selectedGroupId.id,
    location: userLoc,
    orgId,
    userId: taskUserId,
    levelId: levelId || '',
    taskId: taskId || ''
  });

  const markArticleAsRead = (articleId: string) => {
    queryClient.setQueryData([queryKeys.GET_REC_ARTICLES, selectedGroupId.id, orgId, taskUserId], (oldData: any) => {
      if (!oldData?.data?.data) return oldData;

      return {
        ...oldData,
        data: {
          ...oldData.data,
          data: oldData.data.data.map((article: any) =>
            article.id === articleId ? { ...article, isRead: true } : article
          )
        }
      };
    });
  };

  const {
    data: recMentors,
    refetch: fetchRecMentors,
    isLoading: mentorsLoading,
    isFetching: mentorsFetching
  } = useRecMentors({
    grpId: selectedGroupId.id,
    location: userLoc,
    orgId,
    userId: taskUserId,
    levelId: levelId || '',
    taskId: taskId || ''
  });

  // const myMentors = recMentors?.data.MyMentors;
  const personalThreadsArr = useAppSelector((state) => state.acsChannels.personalThreadsArr);
  const [quesLoading, setQuesLoding] = useState<Boolean>(false); // false
  const [quesError, setQuesError] = useState<Boolean>(false);
  const [getTask, setGetTask] = useState<TaskData>({ data: null });
  const taskLoading = isLoading; // menteeTask.loading
  // const taskData = menteeTask.data?.data;
  const oid = useAppSelector((state) => state.orgDetails.data?.oid);
  const taskError = menteeTask.error;
  const [selectProfileRow, setSelectProfileRow] = useState<any>(null);
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [answers, setAnswers] = useState<any>();
  const [isAnswerSaved, setIsAnswerSaved] = useState(false);
  const [isMenteeAsmntAnswerSaved, setIsMenteeAsmtAnswerSaved] = useState(false);
  const [menteeAsmtAnswers, setMenteeAsmtAnswer] = useState<any>();
  const [displayName, setDisplayName] = useState('');
  const [participantUser, setParticipantUser] = useState([]);
  const [openCalendarModal, setCalendarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  // const userWorkHistory = useAppSelector((state) => state.userWorkHistory);
  // const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor'); // Mentor
  // const mentorRoleTextLowerCase = selectedGroupId.id === '64fa3b0ef3cbc20ba20de466' ? 'Matches' : mentorRoleText.toLowerCase(); // mentor
  const [saveAnswersLoading, setSaveAnswersLoading] = useState(false);
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
  const [reloadFlag, setReloadFlag] = useState(false);
  /** For responsive */
  const { mobileBackBtn } = useResponsiveScreenSwitch(); // Use the hook
  // const { forMobile } = useResponsiveScreenSwitch();
  // const userEducation = useAppSelector((state) => state.userEducation);
  const navigate = useNavigate();
  const groupId = selectedGroupId.id || '';
  const completionRedirectPath = isMentee ? '/app/home/user' : '/app/home/user';
  const completionProgramName = selectedGroupId?.name || 'this program';
  // const { isMasterclass, isMentorship, isHybrid } = useModule(); // Fetching current module from Redux state
  const dispatch = useAppDispatch();
  //const xpPoints = menteeTask.data?.xpPoints;
  const selectedTaskRef = useRef<HTMLDivElement | null>(null);
  const getDetailTask = getTask?.data;
  // const isCurrentTask = getDetailTask?._id === taskId;
  const loginUserId = useAppSelector((state) => _.get(state.userProfile.data, '_id', ''));
  const groupDetails = useAppSelector((state) => state?.groupDetails);
  const canEditModules = groupDetails?.data?.includeTask ? groupDetails?.data?.allowEditing : false;
  const currentLevelIndex = levelId && allTaskData ? allTaskData.findIndex((each: any) => each._id === levelId) : -1;
  const moduleNumber = currentLevelIndex >= 0 ? currentLevelIndex + 1 : undefined;
  const lessonNumber = (() => {
    if (!allTaskData || currentLevelIndex < 0 || !taskId) return undefined;
    const taskIndex = allTaskData[currentLevelIndex]?.tasks?.findIndex((each: any) => each._id === taskId);
    return taskIndex >= 0 ? taskIndex + 1 : undefined;
  })();
  const bookedCallDetails: any = '';
  const getTaskById = async ({ groupId, levelId, taskId }: { groupId: string; levelId: string; taskId: string }) => {
    setSelectedDropdownValues({ quesId: '', values: [] });
    if (allTaskData?.length) {
      const level = allTaskData.find((each: any) => each._id === levelId);
      if (level) {
        const task = level.tasks.find((each: any) => each._id === taskId);
        // setInputValue(task.menteeAnswers?.length > 0 ? task.menteeAnswers[0] : '');
        setGetTask({ data: task });
      }
    }
  };
  const [viewedArticles, setViewedArticles] = useState<Record<string, boolean>>(() => {
    const saved = localStorage.getItem('viewedArticles');
    return saved ? JSON.parse(saved) : {};
  });
  // const handleNavigateToChat = (member: any) => {
  //   const listedInCommunity = communityMembers?.find((each) => each?.userId === _.get(member, 'userId', ''));
  //   let isInCommunity = false;
  //   if (listedInCommunity) {
  //     isInCommunity = true;
  //   }
  //   navigateToChat(member?.communicationId, isInCommunity, personalThreadsArr, navigate, dispatch);
  // };

  const data = useUserDetailsById();
  // const userDetails = data?.data?.data?.data;
  const selectedUserId = useAppSelector((state) => state.userId.data);
  const selectedGroup = useAppSelector((state) => state.selectedGroup.data);
  // const selectedUserIdData = useAppSelector((state) => state.goalTasks.userId);

  /** Community member profile redirection */
  // const moveToUsercommunityProfile = (userProfileRow: any) => {
  //   const mem = communityMembers?.find((each) => each?.userId === _.get(userProfileRow, 'userId', ''));

  //   if (mem) {
  //     const modifiedMem = { ...mem, id: _.get(mem, 'id.coId', '') };
  //     const allCommunityMembersList = communityMembers;
  //     let isInCommunity = true;
  //     navigate('/app/communitymember', {
  //       state: { mem: modifiedMem, isInCommunity, allCommunityMembersList: commList }
  //     });
  //   } else {
  //     console.log('Member not found');
  //   }
  // };

  useEffect(() => {
    data.refetch().then(() => {
      if (selectedGroup.role !== 'admin') {
        eventTracking(events.profileViewed, { page: 'Tasks' });
      }
    });
  }, [selectedUserId]);

  useEffect(() => {
    if (selectProfileRow) {
      dispatch(userIdUpdate(selectProfileRow));
    }
  }, [selectProfileRow]);

  // const handleCalendarOpen = (member: any) => {
  //   setDisplayName(member.displayName);
  //   setParticipantUser(member);
  //   setCalendarOpen(true);
  // };

  const handleCalendarClose = () => {
    setDisplayName('');
    setParticipantUser([]);
    setCalendarOpen(false);
  };

  useEffect(() => {
    fetchRecArticles();
    fetchRecMentors();
  }, [selectedGroupId.id, selectedUserId, levelId, taskId]);

  useEffect(() => {
    const updateSize = () => {
      setWindowSize({
        width: window?.innerWidth ?? 0,
        height: window?.innerHeight ?? 0
      });
    };
    updateSize();
    window?.addEventListener('resize', updateSize);
    return () => {
      window?.removeEventListener('resize', updateSize);
    };
  }, []);

  const [lessonCompleteModalOpen, setLessonCompleteModalOpen] = useState(false);
  const closeLessonCompleteModal = () => setLessonCompleteModalOpen(false);
  const [showCompletionOverlay, setShowCompletionOverlay] = useState(false);
  const [completionRedirectInitiated, setCompletionRedirectInitiated] = useState(false);
  const justCompletedRef = useRef(false);

  const allLessonsCompleted = useMemo(() => {
    if (!allTaskData || allTaskData.length === 0) {
      return false;
    }
    return allTaskData.every((level: any) => level.tasks?.every((task: any) => task?.taskColor === 'green'));
  }, [allTaskData]);

  useEffect(() => {
    if (allLessonsCompleted && justCompletedRef.current && !completionRedirectInitiated) {
      justCompletedRef.current = false;
      setLessonCompleteModalOpen(false);
      setShowCompletionOverlay(true);
      const timer = window.setTimeout(() => {
        setShowCompletionOverlay(false);
        setCompletionRedirectInitiated(true);
        navigate(completionRedirectPath);
      }, 5000);
      return () => {
        window.clearTimeout(timer);
      };
    }
    if (!allLessonsCompleted) {
      justCompletedRef.current = false;
    }
    return undefined;
  }, [allLessonsCompleted, completionRedirectInitiated, completionRedirectPath, navigate]);

  const updateAnswers = async () => {
    dispatch(saveAnswerActions.update(true));
    setSaveAnswersLoading(true);
    let success = false;
    setSaveAnswersLoading(true);
    try {
      if (groupId && levelId && taskId) {
        const hasValidAnswer = (item: any) => {
          return (
            item.menteeAns &&
            Array.isArray(item.menteeAns) &&
            item.menteeAns.length > 0 &&
            item.menteeAns.some((ans: any) => ans && ans.trim() !== '')
          );
        };
        const answeredQuestions = menteeQuestions.filter(hasValidAnswer).map((item: any) => ({
          menteeAns: item.menteeAns,
          quesId: item._id
        }));
        const mcqAnswers = mcqQuestions
          .filter((mcq: any) => mcq.MCQAns && mcq.MCQAns.trim() !== '')
          .map((mcq: any) => ({
            MCQquesId: mcq._id,
            MCQAns: mcq.MCQAns,
            result: mcq.result || false
          }));
        const response = await API.saveAnswers({
          groupId,
          levelId,
          taskId,
          menteeAsmtAnswer: menteeAsmtAns || 'yes',
          answers: Array.isArray(answeredQuestions) ? answeredQuestions.filter(Boolean) : [],
          MCQanswers: mcqAnswers,
          cancelToken: source.token
        });
        if (response.status === 200) {
          setIsAnswerSaved(true);
          setIsMenteeAsmtAnswerSaved(true);
          executeInitialTaskData();
          setSelectedDropdownValues({ quesId: '', values: [] });
          toast.success('Answers saved successfully!');
          success = true;
        } else {
          toast.error(response.data);
          success = false;
        }
      }
    } catch (error) {
      dispatch(saveAnswerActions.update(false));
      toast.error('Failed to save answers. Please try again.');
    } finally {
      setSaveAnswersLoading(false);
      dispatch(saveAnswerActions.update(false));
    }
    return success;
  };

  const callGetTaskById = () => {
    if (groupId && levelId && taskId) {
      getTaskById({ groupId: groupId, levelId, taskId });
    }
  };

  useEffect(() => {
    if (!isLoading) {
      callGetTaskById();
    }
  }, [groupId, levelId, taskId, isLoading, allTaskData]);

  useEffect(() => {
    if (reloadFlag) {
      setEditModalOpen(false);
      setReloadFlag(false);
    }
  }, [groupId, reloadFlag]);

  const executeInitialTaskData = () => {
    // if (groupId) {
    //   if (isMentee) {
    //     dispatch(taskActions.setUserId({ userId: '' }));
    //     dispatch(fetchAllTasks({ userId: '', grpId: selectedGroupId.id }));
    //   } else if (isMentor) {
    //     dispatch(taskActions.setUserId({ userId: selectedUserIdData }));
    //     dispatch(fetchAllTasks({ userId: selectedUserIdData, grpId: selectedGroupId.id }));
    //   }
    // }
  };

  const [articleData, setArticleData] = useState<Article>();
  const [openPreview, setOpenPreview] = useState(false);
  const [articleDataLoading, setArticleDataLoading] = useState(false);

  const handelOnClickPreviewArticleName = async (articleId: string, location: string) => {
    markArticleAsRead(articleId);
    const newViewedArticles = { ...viewedArticles, [articleId]: true };
    setViewedArticles(newViewedArticles);
    localStorage.setItem('viewedArticles', JSON.stringify(newViewedArticles));
    setArticleDataLoading(true);
    setOpenPreview(true);
    try {
      const response = await API.getAllArticleById({
        orgId: orgId,
        articleId: articleId,
        isContentSettings: false,
        articleLocation: location ? location : ''
      });

      if (response && response.status === 200) {
        setArticleData(response.data.article);
      }
    } catch (error) {
      toast.error(_.get(error, 'response.data.message', 'Something went wrong, please try again'));
      setOpenPreview(false);
      // console.error(error);
    } finally {
      setArticleDataLoading(false);
    }
  };

  useEffect(() => {
    setAnswers([]);
  }, [taskId]);

  const [selectedLevelId, setSelectedLevelId] = useState<any[]>([]);
  const [selectedLevelName, setSelectedLevelName] = useState('');
  const [rightTopPop, setRightTopPop] = useState(null);
  const rightTopDotsClick = (level: any) => (event: any) => {
    setSelectedLevelId(level._id);
    setSelectedLevelName(level.levelName);
    setEditModalOpen(true);
    setRightTopPop(event.currentTarget);
  };

  const handleClose = () => {
    setEditModalOpen(false);
    setRightTopPop(null);
  };

  const openMoreVert = Boolean(rightTopPop);

  // Goback to home page
  const goBack = () => {
    if (isMentee) {
      navigate('/app/home/mentee'); // Navigate to mentee home page
    } else {
      navigate('/app/home/mentor'); // Navigate to mentor home page
    }
  };

  const rightTopPopover = openMoreVert ? 'simple-popover' : undefined;

  const handleEditLevel = () => {
    dispatch(
      menteeTaskSlicAction.setSelectedLevel({
        selectedLevel: selectedLevelName,
        selectedLevelId: selectedLevelId
      })
    );
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'edit' }));
  };

  const handleDeleteLevel = () => {
    dispatch(
      menteeTaskSlicAction.setSelectedLevel({
        selectedLevelId: selectedLevelId
      })
    );
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'delete' }));
  };

  const handleAddTasks = (level: any) => {
    dispatch(menteeTaskSlicAction.setSelectedLevel({ selectedLevel: level.levelName, selectedLevelId: level._id }));
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'addTask' }));
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const [levelDescription, setLevelDescription] = useState('');
  const [levelNumber, setLevelNumber] = useState(0);
  const handleOpenDescription = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const currentDate = Date.now() / 1000; // Current date in Unix timestamp (seconds)

  function getAvailabilityMessage(startDate: any, endDate: any, type: string, task?: any) {
    let color = '';
    let text = '';
    if (!startDate && !endDate) {
      text = '';
    } else if (startDate && !endDate) {
      if (currentDate >= startDate) {
        text = '';
      } else {
        text = `Available on ${moment.unix(startDate).format('DD/MM/YYYY')} `;
      }
    } else if (currentDate < startDate) {
      text = `Available on ${moment.unix(startDate).format('DD/MM/YYYY')} `;
    } else if (currentDate >= startDate && currentDate <= endDate) {
      const timeLeft = endDate - currentDate;
      if (timeLeft <= 7 * 24 * 3600) {
        // 7 days in seconds
        color = 'orange';
      } else {
        color = '';
      }
      text = `Due by ${moment.unix(endDate).format('DD/MM/YYYY')}`;
    } else if (currentDate > endDate) {
      color = 'red';
      text = `Due by ${moment.unix(endDate).format('DD/MM/YYYY')}`;
    } else {
      text = '';
    }

    if (text === '') return '';

    if (type === 'level') {
      return (
        <Typography fontSize={'12px'} fontStyle={'italic'} color={color}>
          {text}
        </Typography>
      );
    }

    return (
      <Typography
        color={taskId === task._id ? '#FFFFFF' : color}
        fontSize={'12px'}
        lineHeight={'14px'}
        fontStyle={'italic'}
      >
        {text}
      </Typography>
    );
  }

  const getLevelActiveDate = (level: any) => {
    if (level?.startDate?.type === levelTypes.activeNow || level?.startDate === undefined) {
      return true;
    }
    if (level?.startDate?.type === levelTypes.availableSoon) {
      return false;
    }

    if (level?.startDate?.type === levelTypes.calendarDate && currentDate >= level?.startDate?.value) {
      return true;
    }
    if (level?.startDate?.type === levelTypes.daysAfterSignup && currentDate >= level?.startDate?.value) {
      return true;
    }
    return false;
  };
  const handleTaskClick = (levelId: string, taskId: string) => {
    if (place === 'Popup' && onTaskSelect) {
      onTaskSelect(levelId, taskId);
      navigateTaskQuestionsToTop('right');
    } else {
      navigate(`/app/home/mentee/level/${levelId}/task/${taskId}?userName=${userName}`);
    }
  };

  const getAdjacentTask = (direction: 'prev' | 'next') => {
    if (!allTaskData || !levelId || !taskId) return null;
    const levelIndex = allTaskData.findIndex((each: any) => each._id === levelId);
    if (levelIndex < 0) return null;
    const tasks = allTaskData[levelIndex]?.tasks || [];
    const taskIndex = tasks.findIndex((each: any) => each._id === taskId);
    if (taskIndex < 0) return null;

    if (direction === 'next') {
      if (taskIndex < tasks.length - 1) {
        const nextTask = tasks[taskIndex + 1];
        return { levelId, task: nextTask };
      }
      if (levelIndex < allTaskData.length - 1) {
        const nextLevel = allTaskData[levelIndex + 1];
        const nextTask = nextLevel?.tasks?.[0];
        if (nextTask) return { levelId: nextLevel._id, task: nextTask };
      }
    } else {
      if (taskIndex > 0) {
        const prevTask = tasks[taskIndex - 1];
        return { levelId, task: prevTask };
      }
      if (levelIndex > 0) {
        const prevLevel = allTaskData[levelIndex - 1];
        const prevTask = prevLevel?.tasks?.[prevLevel.tasks.length - 1];
        if (prevTask) return { levelId: prevLevel._id, task: prevTask };
      }
    }
    return null;
  };

  const handleNavigateAdjacent = (direction: 'prev' | 'next') => {
    const adjacent = getAdjacentTask(direction);
    if (!adjacent) return;

    const { levelId: nextLevelId, task } = adjacent;
    if (getIsTaskStarted(task?.startDate)) {
      handleTaskClick(nextLevelId, task._id);
    }
  };

  const handleMarkLessonComplete = () => {
    if (!canMarkLessonComplete) {
      toast.warning('Please answer all lesson questions before marking it complete.');
      return;
    }
    if (saveAnswersLoading) {
      return;
    }
    if (isLessonMarkedComplete) {
      return;
    }
    setMenteeAsmtAns('Yes');
    void handleSave('Yes');
  };
  const prevTask = getAdjacentTask('prev');
  const nextTask = getAdjacentTask('next');

  const handleLessonCompleteNext = () => {
    setLessonCompleteModalOpen(false);
    if (nextTask) {
      handleNavigateAdjacent('next');
    }
  };
  const prevNavEnabled = Boolean(prevTask) && !saveAnswersLoading;
  const nextNavEnabled = Boolean(nextTask) && !saveAnswersLoading;

  const renderTaskStatus = (taskColor: string) => {
    const isCompleted = taskColor === 'green';
    return (
      <Box
        className={`mentee-task-row__status-icon ${isCompleted ? 'is-completed' : ''}`}
        data-status={isCompleted ? 'Right' : 'Default'}
      >
        <Box className="mentee-task-row__status-circle" />
        {isCompleted && <CheckIcon className="mentee-task-row__status-check-icon" />}
      </Box>
    );
  };

  const getTasks = (obj: any) => {
    return (
      <>
        {obj.map((level: any, index: number) => {
          const isActiveLevel = level._id === levelId;
          const levelLabel = getOrfiumLevelName(oid, selectedGroupId?.id, index + 1);
          const isLevelAvailable = getLevelActiveDate(level);

          return (
            <React.Fragment key={level._id}>
              <Box className="mentee-task-module">
                <Box className={`mentee-task-module__header ${isActiveLevel ? 'is-active' : ''}`} px={1.5}>
                  <Box>
                    <Typography className="mentee-task-module__label" data-show-due-date="false">
                      {levelLabel}
                    </Typography>
                    <Typography className="mentee-task-module__title">{level.levelName}</Typography>
                    {/* {(level?.endDate?.value || level?.startDate?.value) && (
                      <Typography className="mentee-task-module__availability">
                        {getAvailabilityMessage(level?.startDate?.value, level?.endDate?.value, 'level')}
                      </Typography>
                    )} */}
                  </Box>
                  {!level?.level && canEditModules && (
                    <MoreVertIcon
                      onClick={(event) => rightTopDotsClick(level)(event)}
                      className="cursor-pointer mentee-task-module__more"
                    />
                  )}
                </Box>
                {isLevelAvailable ? (
                  <Box className="mentee-task-module__tasks">
                    {level.tasks.map((task: any, taskIndex: number) => {
                      const isTaskCurrent = taskId === task._id;
                      const isCompleted = task?.taskColor === 'green';
                      const isClickable = getIsTaskStarted(task?.startDate);

                      return (
                        <Box
                          key={task._id}
                          className={`mentee-task-row ${isTaskCurrent ? 'is-active' : ''} ${
                            isCompleted ? 'is-completed' : ''
                          } ${isClickable ? 'clickable' : 'cursor-not-allowed'}`}
                          data-state={isCompleted ? 'Completed' : 'Default'}
                          data-testid="lesson-list-item"
                          onClick={() => {
                            if (isClickable) {
                              handleTaskClick(level._id, task._id);
                            }
                          }}
                        >
                          {renderTaskStatus(task?.taskColor)}
                          <Box className="mentee-task-row__body">
                            <Box className="mentee-task-row__index">
                              <Typography className="mentee-task-row__index-text">{taskIndex + 1}</Typography>
                            </Box>
                            <Box className="mentee-task-row__content">
                              <Typography
                                className="mentee-task-row__title"
                                noWrap
                                ref={isTaskCurrent ? selectedTaskRef : null}
                              >
                                {task.taskName}
                              </Typography>
                              <Typography className="mentee-task-row__meta">
                                {getAvailabilityMessage(task?.startDate, task?.endDate, 'task', task)}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                ) : (
                  <Box className="mentee-task-locked" textAlign="center" px={2} pb={2}>
                    {lockIcon({ size: '35px', color: '#68717A' })}
                    <Typography mt={1}>This level will be available soon.</Typography>
                    <Link
                      color={'info.main'}
                      fontStyle={'italic'}
                      onClick={() => {
                        setLevelNumber(index + 1);
                        setLevelDescription(level?.levelDescription || 'This level has no description');
                        handleOpenDescription();
                      }}
                    >
                      Read description of Module {index + 1}
                    </Link>
                  </Box>
                )}
                {!level?.level &&
                  (level?.startDate?.type === levelTypes.activeNow || level?.startDate === undefined) &&
                  groupDetails?.data?.includeTask &&
                  groupDetails?.data?.allowEditing && (
                    <Link onClick={() => handleAddTasks(level)} color="#0071A9" variant="caption" pl={2}>
                      + Add Lesson
                    </Link>
                  )}
              </Box>

              {index < obj.length - 1 && <Divider className="mentee-task-divider" />}
            </React.Fragment>
          );
        })}
        {/* edit or delete modal */}
        <Popover
          id={rightTopPopover}
          open={editModalOpen}
          anchorEl={rightTopPop}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Box className="PopoverListStyle" gap="8px" onClick={() => handleEditLevel()}>
            <EditIcon />
            <Typography color="primary">Edit Module</Typography>
          </Box>
          <Box className="PopoverListStyle" gap="8px" onClick={() => handleDeleteLevel()}>
            <DeleteIcon />
            <Typography color="primary">Delete Module</Typography>
          </Box>
        </Popover>
        <MenteeTaskPopup setReloadFlag={setReloadFlag} />
      </>
    );
  };

  const getIsTaskStarted = (startDate: any) => {
    const currentDate = Date.now() / 1000; // Current date in Unix timestamp (seconds)
    if (!startDate || currentDate >= startDate) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (selectedTaskRef.current) {
      selectedTaskRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [taskId, selectedTaskRef]);

  const updateQuery = (levels: any) => {
    const newLevels = levels.map((each: any) => {
      if (each?.startDate?.type === levelTypes.activeNow || each?.startDate === undefined) {
        return { ...each, levelColor: 'green' };
      }
      return each;
    });
    const requiredData = newLevels.map((each: any) => {
      let answeredCount = 0;
      let completedCount = 0;
      let mcqAnsweredCount = 0;

      each.tasks?.forEach((task: any) => {
        if (task?.menteeQuestions?.some((q: any) => q.menteeAns?.length > 0) || task.menteeAsmtAns?.length > 0) {
          answeredCount += 1;
        }

        if (task?.menteeAsmtAns && task?.menteeAsmtAns === 'Yes') {
          completedCount += 1;
        }

        if (task?.MCQ?.some((mcq: any) => mcq.MCQAns && mcq.MCQAns.trim() !== '')) {
          mcqAnsweredCount += 1;
        }
      });
      if (completedCount === each.tasks.length) {
        if (each._id === levelId) {
          eventTracking(events.levelCompleted, {});
        }
        return { ...each, hexColor: 'green' };
      } else if (answeredCount >= 1 || mcqAnsweredCount >= 1) {
        return { ...each, hexColor: 'gold' };
      } else {
        return each;
      }
    });
    queryClient.setQueryData([queryKeys.GET_ALL_GROUP_TASKS, selectedGroupId.id, taskUserId], (prev: any) => {
      return { ...prev, data: { ...prev.data, data: [{ ...prev.data.data[0], levels: requiredData }] } };
    });
    dispatch(taskActions.updateTask(requiredData));
  };

  const [menteeQuestions, setMenteeQuestions] = useState<any[]>([]);
  const [menteeAsmtAns, setMenteeAsmtAns] = useState<string>();
  const [mcqQuestions, setMcqQuestions] = useState<any[]>([]);

  const isMenteeQuestionAnswered = (question: any) => {
    const answers = question?.menteeAns;
    if (!Array.isArray(answers)) {
      return Boolean(answers && String(answers).trim() !== '');
    }
    return answers.some((value: any) => Boolean(value) && String(value).trim() !== '');
  };

  const isMcqAnswered = (mcq: any) => Boolean(mcq?.MCQAns && String(mcq.MCQAns).trim() !== '');

  const canMarkLessonComplete = useMemo(() => {
    const allMenteeQuestionsAnswered = menteeQuestions.every((question) => isMenteeQuestionAnswered(question));
    const allMcqAnswered = mcqQuestions.every((mcq) => isMcqAnswered(mcq));
    return allMenteeQuestionsAnswered && allMcqAnswered;
  }, [menteeQuestions, mcqQuestions]);

  const isLessonMarkedComplete = useMemo(() => String(menteeAsmtAns || '').toLowerCase() === 'yes', [menteeAsmtAns]);

  const rawMcqQuestions = _.get(getDetailTask, 'MCQ', []);
  const processedMcqQuestions = rawMcqQuestions.map((mcq: any) => {
    const decryptedCorrectAns = getDecryptAns(mcq.correctAns);
    const correctAnswerIndex = mcq.options.findIndex(
      (option: string) => option.toLowerCase() === decryptedCorrectAns.toLowerCase()
    );

    if (correctAnswerIndex === -1) {
      console.warn('Could not find decrypted answer in options:', {
        decryptedAnswer: decryptedCorrectAns,
        options: mcq.options
      });
    }

    return {
      ...mcq,
      correctAnswerIndex: correctAnswerIndex >= 0 ? correctAnswerIndex : -1,
      decryptedCorrectAns
    };
  });

  useEffect(() => {
    setMenteeQuestions(_.get(getDetailTask, 'menteeQuestions', []));
    setMenteeAsmtAns(_.get(getDetailTask, 'menteeAsmtAns', ''));
    setMcqQuestions(processedMcqQuestions);

    if (getDetailTask && allTaskData && levelId && taskId) {
      const currentLevel = allTaskData.find((level: any) => level._id === levelId);
      if (currentLevel) {
        const currentTask = currentLevel.tasks.find((task: any) => task._id === taskId);
        if (currentTask) {
          const hasAnsweredMCQ = processedMcqQuestions.some((mcq: any) => mcq.MCQAns && mcq.MCQAns.trim() !== '');
          const hasAnsweredQuestions = _.get(getDetailTask, 'menteeQuestions', []).some(
            (q: any) => q.menteeAns?.length > 0
          );
          const hasCompletedAssessment = _.get(getDetailTask, 'menteeAsmtAns', '') === 'Yes';

          const updatedLevels = allTaskData.map((level: any) => {
            if (level._id === levelId) {
              let newHexColor = level.hexColor;

              if (hasCompletedAssessment) {
                newHexColor = 'green';
              } else if (hasAnsweredMCQ || hasAnsweredQuestions) {
                newHexColor = 'gold';
              }

              return { ...level, hexColor: newHexColor };
            }
            return level;
          });

          queryClient.setQueryData([queryKeys.GET_ALL_GROUP_TASKS, selectedGroupId.id, taskUserId], (prev: any) => {
            return { ...prev, data: { ...prev.data, data: [{ ...prev.data.data[0], levels: updatedLevels }] } };
          });
        }
      }
    }
  }, [taskId, levelId, getDetailTask, allTaskData, selectedGroupId.id, taskUserId, queryClient]);

  const handleInputChange = ({ quesId, value }: { quesId: string; value: any }) => {
    setMenteeQuestions((prevQuestions) =>
      prevQuestions.map((question) =>
        question._id === quesId
          ? { ...question, menteeAns: Array.isArray(value) ? value : [value.toString()] }
          : question
      )
    );
  };

  const handleMcqAnswerChange = async (mcqId: string, selectedAnswer: string, isCorrect: boolean) => {
    if (saveAnswersLoading) {
      return;
    }
    setSaveAnswersLoading(true);
    const updatedMcqQuestions = mcqQuestions.map((mcq) =>
      mcq._id === mcqId
        ? {
            ...mcq,
            MCQAns: selectedAnswer,
            result: isCorrect
          }
        : mcq
    );
    setMcqQuestions(updatedMcqQuestions);
    setSaveAnswersLoading(true);

    try {
      if (groupId && levelId && taskId) {
        const answeredQuestions = menteeQuestions
          .filter((item: any) => item.menteeAns?.length > 0)
          .map((item: any) => ({
            menteeAns: item.menteeAns,
            quesId: item._id
          }));

        const mcqAnswers = updatedMcqQuestions
          .filter((mcq: any) => mcq.MCQAns && mcq.MCQAns.trim() !== '') // Filter out unanswered MCQs
          .map((mcq: any) => ({
            MCQquesId: mcq._id,
            MCQAns: mcq.MCQAns,
            result: mcq.result || false
          }));

        const response = await API.saveAnswers({
          groupId,
          levelId,
          taskId,
          menteeAsmtAnswer: menteeAsmtAns || 'yes',
          answers: answeredQuestions,
          MCQanswers: mcqAnswers,
          cancelToken: source.token
        });

        if (response.status === 200) {
          const hasAnsweredMCQ = mcqAnswers.length > 0;
          const requiredData = allTaskData.map((each: any) => {
            if (each._id === levelId) {
              const requiredTasks = each.tasks.map((task: any) => {
                if (task._id === taskId) {
                  return {
                    ...task,
                    menteeQuestions,
                    menteeAsmtAns,
                    MCQ: updatedMcqQuestions,
                    taskColor: menteeAsmtAns === 'Yes' ? 'green' : 'grey'
                  };
                }
                return task;
              });
              return {
                ...each,
                hexColor: hasAnsweredMCQ ? 'gold' : each.hexColor,
                tasks: requiredTasks
              };
            }
            return each;
          });
          updateQuery(requiredData);
          const mcqEventName = isCorrect ? events.mcqAnsweredCorrectly : events.mcqAnsweredIncorrectly;
          eventTracking(mcqEventName, {
            ...amplitudeBaseProps,
            [attributeKeys.resourceType]: 'MCQ',
            levelId,
            taskId,
            mcqQuestionId: mcqId,
            selectedAnswer
          });
          toast.success('Answers saved successfully!');
        }
      }
    } catch (error) {
      console.error('Failed to save answers:', error);
      toast.error('Failed to save answers. Please try again.');
    }
    finally {
      setSaveAnswersLoading(false);
    }
  };

  const handleAddLevels = () => {
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'add' }));
  };

  if (!getIsTaskStarted(getDetailTask?.startDate)) {
    return null;
  }

  /** User details */
  const selectedMentee = selectedMenteeData?.menteeDetails;
  const getBio = (mem: any) => {
    const major: string = mem?.bio?.education?.major;
    const university: string = mem?.bio?.education?.university;
    const role: any = mem?.bio?.workHistory?.role;
    const company: any = mem?.bio?.workHistory?.companyName;

    return bioFormatter(major, university) || bioFormatter(role, company);
  };

  const UserinfoCardDetails = {
    headshot: selectedMentee?.headshot || '',
    displayName: selectedMentee?.displayName || 'Unknown Unknown Unknown Unknown Unknown Unknown',
    UserType: '',
    bio: getBio(selectedMentee) || ''
  };

  const getTaskQuestionOptions: any = (menteeQues: any) => {
    const lowercaseFirstLetter = (options: any) => {
      if (!Array.isArray(options)) return [];
      return options.map((option) => option.charAt(0).toLowerCase() + option.slice(1));
    };

    const camelCaseToCapitalCombined = (ansOptions: string[]) => {
      return ansOptions.map((tag: string) => {
        let index;
        index = topics.findIndex((each: any) => each.name === tag);
        if (index !== -1) return topics[index].label;

        index = industries.findIndex((each: any) => each.name === tag);
        if (index !== -1) return industries[index].label;

        return tag;
      });
    };

    const transformedOptions = lowercaseFirstLetter(menteeQues.menteeAnsOptions);

    // UI constants WITH !important
    const TITLE_STYLE = {
      color: '#FDFDFD !important',
      fontSize: '18px !important',
      fontFamily: 'Open Sans !important',
      fontWeight: '600 !important',
      marginBottom: '8px !important'
    };

    const INPUT_WRAPPER = {
      background: 'rgba(0,0,0,0.70) !important',
      borderRadius: '6px !important',
      outline: '1px solid #868686 !important',
      padding: '8px 12px !important'
    };

    const TEXT_STYLE = {
      color: '#FDFDFD !important',
      fontSize: '14px !important',
      fontFamily: 'Open Sans !important',
      fontWeight: '400 !important'
    };

    // -------------------------------------------------------------
    // INPUT FIELD
    // -------------------------------------------------------------
    if (menteeQues?.menteeAnsType === 'input' && menteeQues?.menteeQues !== 'Question 1') {
      return (
        <Box sx={{ width: '100% !important' }}>
          <Typography sx={TITLE_STYLE}>{menteeQues?.menteeQues}</Typography>

          <Box sx={{ ...INPUT_WRAPPER }}>
            <TextField
              fullWidth
              disabled={!!taskUserId}
              variant="standard"
              multiline
              InputProps={{
                disableUnderline: true,
                sx: {
                  color: '#FDFDFD !important',
                  fontFamily: 'Open Sans !important',
                  fontSize: '14px !important',
                  padding: '0px !important',
                  '&::placeholder': {
                    color: '#868686 !important'
                  }
                }
              }}
              placeholder="Type your message here"
              value={menteeQues?.menteeAns?.[0] || ''}
              onChange={(e) => handleInputChange({ quesId: menteeQues._id, value: e.target.value })}
              sx={{ minHeight: '60px !important' }}
            />
          </Box>

          <Typography
            sx={{
              color: '#B6B6B6 !important',
              fontSize: '12px !important',
              fontFamily: 'Open Sans !important',
              marginTop: '8px !important'
            }}
          >
            Tell us when you decided to step-up your career.
          </Typography>
        </Box>
      );
    }

    // -------------------------------------------------------------
    // RADIO (custom MCQ-like)
    // -------------------------------------------------------------
    if (menteeQues?.menteeAnsType === 'radio') {
      return (
        <Box sx={{ width: '100% !important' }}>
          <Typography sx={TITLE_STYLE}>Select Option</Typography>

          <Box sx={{ display: 'flex !important', flexDirection: 'column !important', gap: '15px !important' }}>
            {['Yes', 'No'].map((each, index) => {
              const isSelected = menteeQues.menteeAns?.includes(each);

              return (
                <Box
                  key={index}
                  onClick={() => {
                    if (!taskUserId) {
                      handleInputChange({ quesId: menteeQues._id, value: each });
                    }
                  }}
                  sx={{
                    cursor: taskUserId ? 'default !important' : 'pointer !important',
                    display: 'flex !important',
                    alignItems: 'center !important',
                    gap: '10px !important',
                    padding: '10px !important',
                    borderRadius: '4px !important',
                    background: '#1C1C1C !important',
                    outline: `1px solid ${isSelected ? '#868686' : '#444444'} !important`,
                    transition: '0.2s !important'
                  }}
                >
                  {/* Custom radio */}
                  <Box sx={{ width: '20px !important', height: '20px !important', position: 'relative !important' }}>
                    <Box
                      sx={{
                        width: '20px !important',
                        height: '20px !important',
                        borderRadius: '50% !important',
                        border: `2px solid ${isSelected ? '#FDFDFD' : '#868686'} !important`,
                        position: 'absolute !important'
                      }}
                    />
                  </Box>

                  <Typography
                    sx={{
                      flex: '1 1 0 !important',
                      fontSize: '14px !important',
                      fontFamily: 'Open Sans !important',
                      fontWeight: isSelected ? '600 !important' : '400 !important',
                      color: isSelected ? '#FDFDFD !important' : '#B6B6B6 !important'
                    }}
                  >
                    {each}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      );
    }

    // -------------------------------------------------------------
    // MULTISELECT (Autocomplete)
    // -------------------------------------------------------------
    if (menteeQues?.menteeAnsType === 'multiselect') {
      return (
        <Box sx={{ width: '100% !important' }}>
          <Typography sx={TITLE_STYLE}>Select Option</Typography>

          <Autocomplete
            multiple
            disableClearable
            disabled={!!taskUserId}
            options={taskUserId ? [] : _.sortBy(camelCaseToCapitalCombined(transformedOptions))}
            value={menteeQues?.menteeAns || []}
            onChange={(e, newValue) => handleInputChange({ quesId: menteeQues._id, value: newValue })}
            popupIcon={false}
            sx={{
              '& .MuiOutlinedInput-root': {
                ...INPUT_WRAPPER,
                '& .MuiChip-root': {
                  background: '#2A2A2A !important',
                  color: '#FDFDFD !important',
                  fontFamily: 'Open Sans !important'
                }
              },
              '& .MuiAutocomplete-endAdornment': {
                display: 'none !important'
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                placeholder="Please Select"
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  sx: {
                    color: '#FDFDFD !important',
                    background: 'black !important',
                    fontFamily: 'Open Sans !important',
                    fontSize: '14px !important'
                  }
                }}
              />
            )}
            renderOption={(props, option) => (
              <Box
                component="li"
                {...props}
                sx={{
                  background: '#151515 !important',
                  px: '12px !important',
                  py: '8px !important',
                  color: '#FDFDFD !important',
                  fontFamily: 'Open Sans !important',
                  fontSize: '14px !important',
                  '&:hover': { background: '#2A2A2A !important' }
                }}
              >
                {option}
              </Box>
            )}
          />
        </Box>
      );
    }

    // -------------------------------------------------------------
    // RATING
    // -------------------------------------------------------------
    if (menteeQues?.menteeAnsType === 'rating') {
      return (
        <Box sx={{ width: '100% !important' }}>
          <Typography sx={TITLE_STYLE}>How would you rate this content?</Typography>

          <Box sx={{ display: 'flex !important', gap: '4px !important' }}>
            {[1, 2, 3, 4, 5].map((n) => {
              const isSelected = parseInt(menteeQues?.menteeAns?.[0], 10) >= n;

              return (
                <Box
                  key={n}
                  onClick={() => {
                    if (!taskUserId) handleInputChange({ quesId: menteeQues._id, value: n });
                  }}
                  sx={{
                    width: '24px !important',
                    height: '24px !important',
                    cursor: taskUserId ? 'default !important' : 'pointer !important',
                    padding: '2px !important',
                    position: 'relative !important'
                  }}
                >
                  <Box
                    sx={{
                      width: '20px !important',
                      height: '20px !important',
                      border: '2px solid #444444 !important',
                      opacity: isSelected ? '1 !important' : '0.5 !important'
                    }}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      );
    }

    return null;
  };

  const handleSave = async (overrideAsmtAns?: string) => {
    let count = 0;
    const finalAsmtAns = overrideAsmtAns ?? menteeAsmtAns;
    if (finalAsmtAns === 'Yes') {
      menteeQuestions?.forEach((each: any) => {
        if (each?.menteeAns?.length === 0) {
          count++;
        }
      });
      if (count > 0) {
        toast.warning('Please answer the question before marking complete');
        return false;
      }
    }
    const requiredData = allTaskData.map((each: any) => {
      if (each._id === levelId) {
        const requiredTasks = each.tasks.map((task: any) => {
          if (task._id === taskId) {
            return {
              ...task,
              menteeQuestions,
              menteeAsmtAns: finalAsmtAns,
              MCQ: mcqQuestions,
              taskColor: finalAsmtAns === 'Yes' ? 'green' : 'grey'
            };
          }
          return task;
        });
        return { ...each, tasks: requiredTasks };
      }
      return each;
    });
    updateQuery(requiredData);
    const finalLessonMarkedComplete = String(finalAsmtAns || '').toLowerCase() === 'yes';
    if (finalLessonMarkedComplete) {
      eventTracking(events.lessonCompleted, {
        ...amplitudeBaseProps,
        [attributeKeys.resourceType]: 'Lesson',
        levelId,
        taskId
      });
    }
    const success = await updateAnswers();
    if (finalLessonMarkedComplete && success) {
      setLessonCompleteModalOpen(true);
      justCompletedRef.current = true;
    }
    return success;
  };
  return (
    <Box className="containerBox mentee-task-container" sx={{ fontFamily: "'Open Sans', sans-serif" }}>
      {isSidebarCollapsed && (
        <Box className="mentee-task-toggle-floating" onClick={() => setIsSidebarCollapsed(false)}>
          <MenuOpenIcon className="mentee-task-toggle-floating__icon" />
        </Box>
      )}
      <Box
        className={`containerBoxLeft d-desktop mentee-task-sidebar ${isSidebarCollapsed ? 'is-collapsed' : ''}`}
        sx={{ overflowY: taskLoading ? 'hidden' : 'auto' }}
      >
        {isSidebarCollapsed ? (
          <Box className="mentee-task-sidebar__collapsed" onClick={() => setIsSidebarCollapsed(false)}>
            {/* <MenuOpenIcon className="mentee-task-sidebar__collapsed-icon" /> */}
          </Box>
        ) : (
          <>
            <Box className="mentee-task-sidebar__header">
              <Box className="mentee-task-sidebar__title">
                {place === 'TaskPage' && taskLoading && (
                  <Box className="mentee-task-sidebar__back" onClick={taskLoading ? undefined : goBack}>
                    <MySkeleton height={18} width={18} />
                  </Box>
                )}
                <Typography className="mentee-task-sidebar__title-text">Program Portfolio</Typography>
              </Box>
              <Box className="mentee-task-sidebar__divider" />
              <Box className="mentee-task-sidebar__action is-clickable" onClick={() => setIsSidebarCollapsed(true)}>
                <MenuOpenIcon className="mentee-task-sidebar__collapsed-icon" />
              </Box>
            </Box>

            <Box className="mentee-task-sidebar__content" overflow={taskLoading ? 'hidden' : 'auto'}>
              {isMentor && place === 'Popup' && (
                <>
                  <UserinfoCard className="p-20" UserinfoCardDetails={UserinfoCardDetails} />
                  <Divider />
                </>
              )}

              {taskLoading ? (
                <TasksLoader />
              ) : allTaskData ? (
                <Box>
                  {allTaskData.length > 0 ? (
                    getTasks(allTaskData)
                  ) : (
                    <Box p={2}>
                      <Typography textAlign="center">No lesson assigned</Typography>
                    </Box>
                  )}
                </Box>
              ) : taskError ? (
                <Box display="flex" gap="8px" alignItems="center" mt={2}>
                  <Error color="error" />
                  <Typography color="error">Failed to load modules</Typography>
                </Box>
              ) : (
                <Box p={2}>
                  <Typography textAlign="center">No lesson assigned</Typography>
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>

      <Box
        className="containerBoxRight"
        sx={{
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          px: '30px',
          py: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '60px',
          background: 'transparent',
          position: 'relative',
          pb: '140px'
        }}
      >
        {/* MOBILE BACK BUTTON */}
        {mobileBackBtn('home')}

        {/* Mentor Badge */}
        {isMentor && place === 'TaskPage' && <MentorViewBadge userName={userName} />}

        {/* -------------------------  HEADER SECTION ------------------------- */}
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '30px'
          }}
        >
          {/* Title + Module / Lesson row */}
          <Box display="flex" flexDirection="column" gap="20px">
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <Typography sx={{ color: '#B6B6B6', fontSize: '14px', fontFamily: 'Open Sans' }}>
                Module {moduleNumber || 1}
              </Typography>

              <Typography sx={{ color: '#B6B6B6', fontSize: '14px', fontFamily: 'Open Sans' }}>
                Lesson {lessonNumber || 1}
              </Typography>

              {/* RIGHT ICONS */}
              <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <QuestionMarkIcon sx={{ color: '#B6B6B6', fontSize: 18 }} />
                </Box>
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <FlagOutlinedIcon sx={{ color: '#FDFDFD', fontSize: 18 }} />
                </Box>
              </Box>
            </Box>

            {/* Title of Lesson */}
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '20px'
              }}
            >
              <Typography
                sx={{
                  flex: 1,
                  color: '#FDFDFD',
                  fontSize: '30px',
                  fontWeight: 600,
                  fontFamily: 'Open Sans'
                }}
              >
                {getDetailTask?.taskName}
              </Typography>

              {/* Duration */}
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography
                  sx={{
                    color: '#868686',
                    fontSize: '12px',
                    fontWeight: 600
                  }}
                >
                  ~{getDetailTask?.duration || '6'}’ to complete lesson
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* DESCRIPTION */}
          <Box
            sx={{
              width: '100%',
              display: 'flex'
            }}
          >
            {isLoading ? (
              <TasksQuesLoader />
            ) : quesError ? (
              <Box display="flex" alignItems="center">
                <Error color="error" />
                <Typography sx={{ ml: 1, color: 'red' }}>Failed to load lesson</Typography>
              </Box>
            ) : (
              <Typography
                sx={{
                  color: '#B6B6B6',
                  fontSize: '14px',
                  lineHeight: '24px',
                  fontFamily: 'Open Sans'
                }}
              >
                <RenderHTML htmlContent={getDetailTask?.taskDescription} fallbackText="No description found" />
              </Typography>
            )}
          </Box>
        </Box>

        {/* DIVIDER */}
        <Divider sx={{ borderColor: '#2A2A2A' }} />

        {/* ---------------------- LESSON MATERIALS ---------------------- */}
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Typography sx={{ color: '#FDFDFD', fontSize: '16px', fontWeight: 700 }}>Lesson Materials</Typography>

          <RecommendedArticle
            direction="row"
            place="menteeTask"
            isLoading={articlesLoading || articlesFetching}
            data={recArticles?.data?.data || []}
            handleArticleClick={(id, location) => handelOnClickPreviewArticleName(id, location)}
            viewedArticles={viewedArticles}
          />
        </Box>

        {/* DIVIDER */}
        <Divider sx={{ borderColor: '#2A2A2A' }} />

        {/* ---------------------- MENTEE QUESTIONS ---------------------- */}
        {menteeQuestions.length > 0 && (
          <Box
            sx={{
              width: '100%',
              maxWidth: 500,
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              fontFamily: "'Open Sans', sans-serif"
            }}
          >
            <Typography sx={{ color: '#444444', fontSize: '12px', fontFamily: 'Open Sans' }}>
              Multiple Choice Question
            </Typography>

            {menteeQuestions.map((question, i) => {
              return (
                <Box key={question._id}>
                  <Box display="flex" alignItems="center" pb={2} gap={1}>
                    <Typography
                      variant="h5"
                      sx={{
                        color: '#FDFDFD',
                        opacity: isMentor ? 0.25 : 1,
                        fontFamily: 'Open Sans'
                      }}
                    >
                      {question.menteeQues}
                    </Typography>
                    {isMentor &&
                      lockIcon({ size: '16px', color: '#68717A', title: "You can not edit this person's answers" })}
                  </Box>

                  {getTaskQuestionOptions(question)}

                  {i < menteeQuestions.length - 1 && <Box sx={{ my: '20px' }} />}
                </Box>
              );
            })}
          </Box>
        )}

        {/* ---------------------- MCQ QUESTIONS ---------------------- */}
        <Box sx={{ width: '100%', maxWidth: 500, display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {mcqQuestions.map((mcq, index) => (
            <Box key={mcq._id}>
              <MCQQuestion
                question={mcq.ques}
                options={mcq.options}
                correctAnswerIndex={mcq.correctAnswerIndex}
                disabled={isMentor}
                showLockIcon={isMentor}
                selectedAnswer={mcq.MCQAns}
                isAnswered={!!mcq.MCQAns}
                onSubmit={(selectedAnswer: string, isCorrect: boolean) =>
                  handleMcqAnswerChange(mcq._id, selectedAnswer, isCorrect)
                }
              />
              {index < mcqQuestions.length - 1 && (
                <Box sx={{ width: '100%', height: '1px', background: '#444444', my: '20px' }} />
              )}
            </Box>
          ))}
        </Box>

        {/* SAVE BUTTON */}
        {/* {isMentee && (
          <Box sx={{ width: '100%', maxWidth: 500, display: 'flex', justifyContent: 'flex-end' }}>
            <LoadingButton
              color="primary"
              loading={saveAnswersLoading}
              variant="contained"
              sx={{
                height: '50px',
                width: '150px'
              }}
              onClick={() => handleSave()}
            >
              Save
            </LoadingButton>
          </Box>
        )} */}

        {/* Fixed Footer CTA */}
        {isMentee && (
          <Box className="mentee-task-footer">
            <Box
              className={`mentee-task-footer__link ${prevNavEnabled ? 'is-active' : 'is-disabled'}`}
              onClick={() => {
                if (!prevNavEnabled) return;
                handleNavigateAdjacent('prev');
              }}
              aria-disabled={!prevNavEnabled}
              sx={{ cursor: prevNavEnabled ? 'pointer' : 'not-allowed' }}
            >
              <ArrowBackIosNewOutlinedIcon className="mentee-task-footer__icon" />
              <Typography className="mentee-task-footer__link-text">Last Lesson</Typography>
            </Box>

            <Box className="mentee-task-footer__divider" />

            <LoadingButton
              className={`mentee-task-footer__cta ${
                !canMarkLessonComplete || isLessonMarkedComplete || saveAnswersLoading ? 'is-disabled' : ''
              }`}
              loading={saveAnswersLoading}
              loadingPosition="center"
              onClick={handleMarkLessonComplete}
              disabled={!canMarkLessonComplete || isLessonMarkedComplete || saveAnswersLoading}
              aria-disabled={!canMarkLessonComplete || isLessonMarkedComplete || saveAnswersLoading}
              sx={{
                cursor:
                  !canMarkLessonComplete || isLessonMarkedComplete || saveAnswersLoading ? 'not-allowed' : 'pointer',
                textTransform: 'none',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              {saveAnswersLoading ? (
                <CircularProgress size={18} sx={{ color: '#fff' }} />
              ) : (
                <Typography className="mentee-task-footer__cta-text">Mark Lesson Complete</Typography>
              )}
            </LoadingButton>

            <Box className="mentee-task-footer__divider" />

            <Box
              className={`mentee-task-footer__link ${nextNavEnabled ? 'is-active' : 'is-disabled'}`}
              onClick={() => {
                if (!nextNavEnabled) return;
                handleNavigateAdjacent('next');
              }}
              aria-disabled={!nextNavEnabled}
              sx={{ cursor: nextNavEnabled ? 'pointer' : 'not-allowed' }}
            >
              <Typography className="mentee-task-footer__link-text">Next Lesson</Typography>
              <ArrowForwardIosOutlinedIcon className="mentee-task-footer__icon" />
            </Box>
          </Box>
        )}

        {lessonCompleteModalOpen && !showCompletionOverlay && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0, 0, 0, 0.65)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1400,
              px: 2
            }}
            onClick={closeLessonCompleteModal}
          >
            <Confetti
              width={windowSize.width}
              height={windowSize.height}
              run={lessonCompleteModalOpen}
              recycle={false}
              numberOfPieces={600}
              gravity={1}
              initialVelocityY={20}
              style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}
            />
            <Box
              sx={{
                width: 550,
                bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
                borderRadius: 2,
                outline: '1px solid var(--Stroke-Modal-border, #444444)',
                outlineOffset: '-1px',
                display: 'inline-flex',
                flexDirection: 'column',
                fontFamily: "'Open Sans', sans-serif"
              }}
              onClick={(event) => event.stopPropagation()}
            >
              <Box
                sx={{
                  width: '100%',
                  position: 'relative',
                  borderBottom: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  px: 5.625,
                  py: 2.5,
                  gap: 2
                }}
              >
                <Box sx={{ flex: '1 1 0', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                  <Typography
                    sx={{
                      flex: '1 1 0',
                      textAlign: 'center',
                      color: 'var(--Text-text-primary, #FDFDFD)',
                      fontSize: 18,
                      fontWeight: 700
                    }}
                  >
                    Lesson Complete
                  </Typography>
                </Box>
                <IconButton
                  onClick={closeLessonCompleteModal}
                  sx={{
                    position: 'absolute',
                    right: 20,
                    top: 18,
                    color: 'var(--Text-text-primary, #FDFDFD)'
                  }}
                  size="small"
                >
                  <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  alignSelf: 'stretch',
                  px: 3.125,
                  py: 2.5,
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2
                }}
              >
                <Typography
                  sx={{
                    textAlign: 'center',
                    color: 'var(--Text-text-secondary, #B6B6B6)',
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: '19.88px'
                  }}
                >
                  Nice work! You’ve wrapped up this lesson.
                </Typography>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <Box
                    sx={{
                      px: 1.75,
                      py: 1.25,
                      background:
                        'linear-gradient(180deg, var(--orange-500, #F79420) 0%, var(--orange-700, #F15A26) 100%)',
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      gap: 1
                    }}
                    onClick={handleLessonCompleteNext}
                  >
                    <Typography
                      sx={{
                        color: 'var(--Stroke-Button-button-cta-default, #FDFDFD)',
                        fontSize: 13,
                        fontWeight: 600,
                        lineHeight: '19.5px'
                      }}
                    >
                      Next Lesson
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        {/* MODALS */}
        <CallBookingModal
          handleCloseModal={handleCalendarClose}
          openFlag={openCalendarModal}
          chatProfileName={displayName}
          threadParticipantsUsers={[participantUser]}
          chatType="Chats"
          pageName="Mentor"
          bookedCallDetails={bookedCallDetails}
        />

        <PreviewContent
          openPreview={openPreview}
          setOpenPreview={setOpenPreview}
          singleListData={articleData}
          loading={articleDataLoading}
        />
      </Box>

      <Box className="mentee-task-spacer" />

      {/* Description Modal */}
      <DescriptionModal
        open={isModalOpen}
        onClose={handleCloseModal}
        title={`Module ${levelNumber} Description`}
        message={levelDescription}
      />
      {showCompletionOverlay && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            position: 'fixed',
            top: 0,
            left: 0,
            background: 'var(--Fill-background, #0F0F0F)',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            display: 'inline-flex',
            zIndex: 2500
          }}
        >
          <Confetti
            width={windowSize.width}
            height={windowSize.height}
            run={showCompletionOverlay}
            recycle={false}
            numberOfPieces={600}
            gravity={1}
            initialVelocityY={20}
            style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}
          />
          <Box
            sx={{
              flex: '1 1 0',
              alignSelf: 'stretch',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              display: 'inline-flex'
            }}
          >
            <Box
              sx={{
                alignSelf: 'stretch',
                flex: '1 1 0',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                display: 'flex'
              }}
            >
              <Box
                sx={{
                  alignSelf: 'stretch',
                  flex: '1 1 0',
                  px: 3,
                  pt: 13,
                  pb: 13,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 10,
                  display: 'flex'
                }}
              >
                <Box
                  sx={{
                    width: 600,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 5,
                    display: 'flex'
                  }}
                >
                  <Typography
                    sx={{
                      textAlign: 'center',
                      color: 'var(--Text-text-primary, #FDFDFD)',
                      fontSize: 30,
                      fontFamily: 'Open Sans',
                      fontWeight: 500,
                      wordWrap: 'break-word'
                    }}
                  >
                    You completed:
                  </Typography>
                  <Typography
                    sx={{
                      textAlign: 'center',
                      color: 'var(--Text-text-primary, #FDFDFD)',
                      fontSize: 30,
                      fontFamily: 'Open Sans',
                      fontWeight: 700,
                      wordWrap: 'break-word'
                    }}
                  >
                    {completionProgramName}
                  </Typography>
                  <Typography
                    sx={{
                      textAlign: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'var(--Text-text-secondary, #B6B6B6)',
                      fontSize: 16,
                      fontFamily: 'Open Sans',
                      fontWeight: 600,
                      lineHeight: '20.80px',
                      wordWrap: 'break-word'
                    }}
                  >
                    See you in a few seconds!
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MenteeTask;
